import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PartnerService } from '../../../services/partner.service';

@Component({
  selector: 'app-map-pro-to-partner-group-modal',
  templateUrl: './map-pro-to-partner-group-modal.component.html',
  styleUrls: ['./map-pro-to-partner-group-modal.component.scss']
})
export class MapProToPartnerGroupModalComponent implements OnInit {

  proShow: any;
  importShow: any;
  proShows: any
  partnerGroups: any;
  selectedPartnerGroup: any;

  constructor(    
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<MapProToPartnerGroupModalComponent>,
    private partnerService: PartnerService
  ) { }

  ngOnInit() {

    if (this.data.proShow) {
      this.proShow = this.data.proShow;
    }
    if (this.data.proShows) {
      this.proShows = this.data.proShows;
    }
    if (this.data.importShow) {
      this.importShow = this.data.importShow;
    }
    if (this.data.partnerGroups) {
      this.partnerGroups = this.data.partnerGroups;
    }
    
    if (this.importShow) {
      this.findShowById();
    }
    if (this.proShow.partnerGroup_id) {
      this.selectedPartnerGroup = this.partnerGroups.find(group => group.id === this.proShow.partnerGroup_id);
    }
  }

  findShowById() {
    this.proShow = this.proShows.find(show => show.id === this.importShow.PROShowId);
  }

  findPartnerGroupById() {
    this.selectedPartnerGroup = this.partnerGroups.find(group => group.id === this.proShow.partnerGroup_id);
  }

  save() { 
    // if (this.importShow) {
    //   this.findShowById();
    // }
    this.partnerService.updateProShow(this.proShow.id, this.proShow.title, this.proShow.description, this.selectedPartnerGroup.id).subscribe( (res: any) => {
      console.log(res);
      this.close();
    });
  }

  trackById(_: number, item: any) {
    return item.id;
  }

  close(): void {
    this.dialogRef.close();
    this.partnerService.notifyModalClosed(); // Notify modal closed  
  }

  cancel(): void {
    this.dialogRef.close();
  }

}
